import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  fields: {
    display: 'flex'
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    paddingRight: 10,
    width: 150
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 800,
    textTransform: 'uppercase',
    marginBottom: 5
  },
  value: {
    overflow: 'hidden',
    fontSize: '1.1em',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    textTransform: 'none'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addtitle/AddTitle.styles.js